var _circle, _circle2, _g, _circle3, _g2, _circle4, _g3, _circle5, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 336,
    viewBox: "0 0 336 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    fill: "#FF6A45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_9632",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 336
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_9632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 24C96.6274 24 102 29.3726 102 36C102 42.6274 96.6274 48 90 48H41C34.3726 48 29 53.3726 29 60C29 66.6274 34.3726 72 41 72H168C174.627 72 180 66.6274 180 60C180 53.3726 174.627 48 168 48H155L154.999 47.9897C148.604 47.727 143.5 42.4595 143.5 36C143.5 29.5405 148.604 24.273 154.999 24.0103L155 24H211C217.627 24 223 18.6274 223 12C223 5.37258 217.627 0 211 0H55C48.3726 0 43 5.37258 43 12C43 18.6274 48.3726 24 55 24H90ZM286 60C286 53.3726 280.627 48 274 48H269C262.373 48 257 53.3726 257 60C257 66.6274 262.373 72 269 72H274C280.627 72 286 66.6274 286 60Z",
    fill: "#FF9B6B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_9632",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 336
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_9632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 312C203.627 312 209 317.373 209 324C209 330.627 203.627 336 197 336H148C141.373 336 136 341.373 136 348C136 354.627 141.373 360 148 360H275C281.627 360 287 354.627 287 348C287 341.373 281.627 336 275 336H262L261.999 335.99C255.604 335.727 250.5 330.46 250.5 324C250.5 317.54 255.604 312.273 261.999 312.01L262 312H318C324.627 312 330 306.627 330 300C330 293.373 324.627 288 318 288H162C155.373 288 150 293.373 150 300C150 306.627 155.373 312 162 312H197ZM393 348C393 341.373 387.627 336 381 336H376C369.373 336 364 341.373 364 348C364 354.627 369.373 360 376 360H381C387.627 360 393 354.627 393 348Z",
    fill: "#FF9B6B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_9632",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 336
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_9632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 72C145.627 72 151 77.3726 151 84C151 90.6274 145.627 96 139 96H99C92.3726 96 87 90.6274 87 84C87 77.3726 92.3726 72 99 72H139ZM263 168C269.627 168 275 173.373 275 180C275 186.627 269.627 192 263 192H112L111.999 192.01C105.604 192.273 100.5 197.54 100.5 204C100.5 210.46 105.604 215.727 111.999 215.99L112 216H131C137.627 216 143 221.373 143 228C143 234.627 137.627 240 131 240H11C4.37258 240 -1 234.627 -1 228C-1 221.373 4.37258 216 11 216H43C49.6274 216 55 210.627 55 204C55 197.373 49.6274 192 43 192H-21C-27.6274 192 -33 186.627 -33 180C-33 173.373 -27.6274 168 -21 168H263ZM112 276C112 269.373 106.627 264 100 264H80C73.3726 264 68 269.373 68 276C68 282.627 73.3726 288 80 288H100C106.627 288 112 282.627 112 276ZM229 276C229 269.373 223.627 264 217 264H155C148.373 264 143 269.373 143 276C143 282.627 148.373 288 155 288H217C223.627 288 229 282.627 229 276ZM223 228C223 221.373 217.627 216 211 216H191C184.373 216 179 221.373 179 228C179 234.627 184.373 240 191 240H211C217.627 240 223 234.627 223 228ZM360 84C360 77.3726 354.627 72 348 72H308C301.373 72 296 77.3726 296 84C296 90.6274 301.373 96 308 96H348C354.627 96 360 90.6274 360 84Z",
    fill: "#D04237"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_9632",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 336
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 168,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_9632)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0775757,
    x: 169,
    y: -16,
    width: 184,
    height: 368,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMars);
export default __webpack_public_path__ + "static/media/Mars.ce16c750bb02b31498875c21bbaa7d3c.svg";
export { ForwardRef as ReactComponent };